import React from 'react'
import {
  // Button,
  FormDashboardTextarea as Textarea,
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Radio,
  FormRow,
  FileUploader,
  MediaUploader,
  Checkbox
} from '../../../components'


// eslint-disable-next-line no-unused-vars
const ResourceType = ({form, updateForm}) => {
  return (
    <div>
      <Label>Resource Type</Label>
      <div className="flex flex-wrap lg:items-center mb-4 pt-1">
        <div className="w-1/2 lg:w-auto">
          <Radio
            name="type"
            id="type1"
            value="embed"
            label="Embedded PDF"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={updateForm}
          />
        </div>
        <div className="w-1/2 lg:w-auto">
          <Radio
            name="type"
            id="type2"
            value="download"
            label="Downloadable File"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={updateForm}
          />
        </div>
        <div className="w-1/2 lg:w-auto">
          <Radio
            name="type"
            id="type3"
            value="video"
            label="Video"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={updateForm}
          />
        </div>
        <div className="w-1/2 lg:w-auto">
          <Radio
            name="type"
            id="type4"
            value="audio"
            label="Audio"
            className="mr-5 mb-2 lg:mb-0"
            form={form}
            onChange={updateForm}
          />
        </div>
      </div>
      {
        form.type === 'embed' &&
        <Input className="w-full" placeholder="Link" defaultValue="issuu.com/e/peace-in-times-of-suffering-in-times-of-loss-tickets-1075..."/>
      }
      {
        form.type === 'download' &&
        <FileUploader />
      }
      {
        form.type === 'video' &&
        <MediaUploader type="Video"/>
      }
      {
        form.type === 'audio' &&
        <MediaUploader type="Audio"/>
      }
    </div>
  )
}

const Form = () => {
  const [form, setForm] = React.useState({
    type: 'embed'
  })

  // eslint-disable-next-line no-unused-vars
  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  return (
    <form>
      <div className="lg:hidden">
        <div className="mobile-fullwidth">
          <div className="p-6 rounded mb-8" style={{background: '#f5f5f5'}}>
            <p className="text-sm text-gray-444 text-center">
              Status: <strong>Published</strong>
            </p>
          </div>
        </div>
      </div>
      <p className="text-lg font-bold mb-5 lg:mb-8">Title</p>
      <FormRow>
        <Label>Title (English)</Label>
        <Input className="w-full" defaultValue="Indonesia Millenial Summit 2020"/>
      </FormRow>
      <FormRow last>
        <Label>Title (Indonesia)</Label>
        <Input className="w-full" defaultValue="Indonesia Millenial Summit 2020"/>
      </FormRow>

      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">Options</p>
      <FormRow last>
        {/* <ResourceType form={form} updateForm={updateForm}/> */}

        <Label>Categories</Label>
        <div className="flex pt-2">
          <div className="mr-16">
            <Checkbox itemsCentered className="mb-4" id="checkbox1" label="Kebijakan Nasional/Daerah" defaultChecked={true}/>
            <Checkbox itemsCentered className="mb-4" id="checkbox2" label="Hasil Penelitian"/>
          </div>
          <div className="mr-16">
            <Checkbox itemsCentered className="mb-4" id="checkbox3" label="Buku & Modul"/>
            <Checkbox itemsCentered className="mb-4" id="checkbox4" label="Instrumen/Panduan" defaultChecked={true}/>
          </div>
          {/* <div className="">
            <Checkbox itemsCentered className="mb-4" id="checkbox5" label="Zine"/>
            <Checkbox itemsCentered className="mb-4" id="checkbox6" label="News"/>
          </div> */}
        </div>
      </FormRow>

      <hr className="mb-8"/>

      <p className="text-lg font-bold mb-5 lg:mb-8">About</p>
      <FormRow>
        <Label>About (English)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>
      <FormRow>
        <Label>About (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={10}
          defaultValue={
            `Bahasa Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.

            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud ollit non deserunt ullamco est sit aliqua dolor do amet sint. `
          }
        />
      </FormRow>
    </form>
  )
}

export { Form }
